import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import QuickFilterPill from 'components/search/QuickFilterPills/QuickFilterPill';
import { useQuickFilterPills } from 'hooks/useQuickFilterPills';

export interface QuickFilterPillsProps {
  /** Latest Total Result count based on the filters selection. */
  totalProductCount: number; // same source as the full FacetsDrawer (products.totalProductCount).
}

const QuickFilterPills = ({ totalProductCount }: QuickFilterPillsProps) => {
  const quickFilterPills = useQuickFilterPills();

  // Renders a fragment so the pills are direct flex children
  // of the StandardSearch scroll row alongside the Filters button.
  return (
    <>
      {quickFilterPills.map(pill => (
        <QuickFilterPill
          key={pill.id}
          label={pill.label}
          drawerTitle={pill.drawerTitle}
          selectedCount={pill.selectedCount}
          totalProductCount={totalProductCount}
          dataTestId={`quickFilterPill-${pill.id}`}
          sections={pill.sections}
          activeSectionId={pill.activeSectionId}
          defaultExpandedSectionIds={pill.defaultExpandedSectionIds}
        />
      ))}
    </>
  );
};

// A render failure hides only the pill row; the Filters button beside it stays usable.
export default withErrorBoundary('QuickFilterPills', QuickFilterPills);
